import { put, select } from "redux-saga/effects";
import { Registerer, RegistererState } from "sip.js";
import { setUA, setRegisterer, setUAState, selectUA, incReconnectionAttempt, selectRegisterer } from "../../../state/userAgent/userAgentSlice";
import { attemptReconnectAction } from "../attemptReconnect/action";
import store from "../../../state/store";

let registrationTimeoutTimer = null;

export function* addRegistrarSaga() {
    const ua = yield select(selectUA);
    try {
        let registerer = yield select(selectRegisterer);
        if (!registerer || registerer.state === RegistererState.Terminated) {
            registerer = new Registerer(ua);
            yield put(setRegisterer(registerer));

            registerer.stateChange.addListener((newState) => {
                const state = store.getState();
                const { isLoggedIn } = state.login;
                switch (newState) {
                    case RegistererState.Initial:
                        store.dispatch(setUAState('init'));
                        break;
                    case RegistererState.Registered:
                        if (registrationTimeoutTimer) {
                            clearTimeout(registrationTimeoutTimer)
                            registrationTimeoutTimer = null;
                        }
                        store.dispatch(setUAState('registered'));
                        break;


                    case RegistererState.Terminated:
                        store.dispatch(setUAState('closed'));
                        break;

                    case RegistererState.Unregistered:
                        console.log('Register unregistered', Date.now())
                        if (isLoggedIn && !registrationTimeoutTimer ) {
                            console.log('Register trying to stop UA', Date.now())
                            registrationTimeoutTimer = setTimeout(() => {
                                ua.stop().then(() => {
                                    console.log('We hit attemptReconnect from addRegistrar Unregistered', Date.now())
                                    store.dispatch(attemptReconnectAction());
                                });
                                registrationTimeoutTimer = null;
                            }, 3000);
                        }
                        store.dispatch(setUAState('unregistered'));
                        break;
                    default:

                }
            });
        }
        console.debug('pre-register registerer state:', registerer.state);
        try {
            yield registerer?.register({
                requestDelegate: {
                    onReject(response) {
                        console.debug('register onReject:', response);
                        if (response.message.statusCode === 503 || response.message.statusCode === 500) {
                            store.dispatch(incReconnectionAttempt());
                        }
                    },
                },
            });
        } catch (e) {
            console.log(e)

        }

    } catch (e) {
        console.error('Failed to Register', e);
        yield put(setUA(null));
        yield put(setRegisterer(null));
        console.log('We hit attemptReconnect from addRegistrar catch block', Date.now())
        yield put(attemptReconnectAction());

    }


}
